import {ContentCategoryApi} from "../generated-api";
import {API_CONFIG} from "app/api-config";
import {createAsyncThunk} from "@reduxjs/toolkit";

const categoryApi = new ContentCategoryApi(API_CONFIG);

export const fetchCategories = createAsyncThunk('category/list', async () => {
    return await categoryApi.contentCategoriesGet();
});
